import React from 'react';

import { TooltipRenderFnProps } from '../../utils/ChartProps';
import { DataKeyType } from '../../utils/DataProps';
import { DefaultTooltipContent, DefaultTooltipContentProps } from './DefaultTooltipContent';

export interface CreateTooltipRenderFnParams<TValueType extends number, TDataKeyType extends DataKeyType, TDatum>
  extends Pick<
    DefaultTooltipContentProps<TValueType, TDataKeyType, TDatum>,
    | 'dataKeyGetter'
    | 'descriptionRenderer'
    | 'labelGetter'
    | 'valueGetter'
    | 'title'
    | 'showTotal'
    | 'showPercentage'
    | 'showTime'
    | 'showOtherItems'
  > {}

export const createTooltipRenderer = <TValueType extends number, TDataKeyType extends DataKeyType, TDatum>({
  dataKeyGetter,
  descriptionRenderer,
  labelGetter,
  title,
  valueGetter,
  showTotal,
  showPercentage,
  showTime,
  showOtherItems,
}: CreateTooltipRenderFnParams<TValueType, TDataKeyType, TDatum>) => {
  return ({ data, activeDataKey, colorScale, date }: TooltipRenderFnProps<TDataKeyType, TDatum>): JSX.Element => {
    return (
      <DefaultTooltipContent
        valueGetter={valueGetter}
        dataKeyGetter={dataKeyGetter}
        labelGetter={labelGetter}
        data={data}
        descriptionRenderer={descriptionRenderer}
        activeDataKey={activeDataKey}
        title={title}
        showTotal={showTotal}
        showPercentage={showPercentage}
        showTime={showTime}
        colorScale={colorScale}
        date={date}
        showOtherItems={showOtherItems}
      />
    );
  };
};
